import { NavLink } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { DASHBOARD_ROUTES } from '@/api/constants/app.url';
import { useCan } from '@/shared/access';
import { navLinkClass } from './nav-link-class';

export function SettingsLink({ collapsed = false }: { collapsed?: boolean }) {
    // The parent "Settings → View" Role Matrix permission is the master switch
    // for the whole area — without it the menu disappears. Owners always pass.
    const allowed = useCan('settings.view');
    if (!allowed) return null;

    return (
        <NavLink
            to={DASHBOARD_ROUTES.SETTINGS}
            className={({ isActive }) => navLinkClass({ isActive, collapsed })}
            title={collapsed ? 'Settings' : undefined}
            aria-label={collapsed ? 'Settings' : undefined}
        >
            <Settings className="h-4 w-4 shrink-0" strokeWidth={2} />
            {!collapsed && <span>Settings</span>}
        </NavLink>
    );
}
